import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=206ceaad&scoped=true"
import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=206ceaad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ceaad",
  null
  
)

export default component.exports